import { create } from 'zustand';
import { getSearchData } from './api';
import { logError } from "@/app/[lang]/utils/logger";

type SearchData = {
    data: {
        id: 1,
        attributes: {
            searchButtonText: string,
            resultsText: string,
            total: string,
            articles: string,
            solutions: string,
            faqs: string,
            moreResultsText: string,
            noResultsText: string,
            searchError: string,
            locale: string
        }
    },
    meta: {}
}

type SearchStore = {
  searchData: SearchData | null;
  isLoading: boolean;
  fetchSearchData: () => Promise<void>;
};

// Define a Zustand store
export const useSearchStore = create<SearchStore>((set) => ({
    searchData: null,
    isLoading: false,
    fetchSearchData: async () => {
      set({ isLoading: true });
      try {
        const data = await getSearchData(); // Assuming getSearchData is a function that makes the API request
        set({ searchData: data });
      } catch (error) {
        // Handle errors if necessary
        logError('Error fetching search data:', error);
      } finally {
        set({ isLoading: false });
      }
    },
}));
